module.exports = __webpack_public_path__ + "static/media/search.c0999df3.svg";